/**
 * AdminPanel Component
 * Main administrative interface for messaging system management
 * Provides access to user management, content moderation, and announcements
 */

import React, { useState } from 'react';
import { Container, Row, Col, Nav, Tab } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUsers,
  faFlag,
  faBullhorn,
  faChartLine
} from '@fortawesome/free-solid-svg-icons';
import MessageReportList from './MessageReportList';
import AnnouncementCreator from './AnnouncementCreator';
import UserModerationPanel from './UserModerationPanel';
import './AdminPanel.css';

/**
 * AdminPanel - Main administrative interface
 * @param {Object} props - Component props
 * @param {Object} props.user - Current user object
 * @returns {JSX.Element} AdminPanel component
 */
const AdminPanel = ({ user }) => {
  const [activeTab, setActiveTab] = useState('reports');

  return (
    <Container fluid className="admin-panel">
      <Row className="admin-panel-header">
        <Col>
          <h2>
            <FontAwesomeIcon icon={faChartLine} className="me-2" />
            Administration Panel
          </h2>
          <p className="text-muted">
            Manage users, moderate content, and create announcements
          </p>
        </Col>
      </Row>

      <Tab.Container activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
        <Row>
          <Col md={2} className="admin-panel-sidebar">
            <Nav variant="pills" className="flex-column">
              <Nav.Item>
                <Nav.Link eventKey="reports">
                  <FontAwesomeIcon icon={faFlag} className="me-2" />
                  Reported Messages
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="moderation">
                  <FontAwesomeIcon icon={faUsers} className="me-2" />
                  User Moderation
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="announcements">
                  <FontAwesomeIcon icon={faBullhorn} className="me-2" />
                  Announcements
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>

          <Col md={10} className="admin-panel-content">
            <Tab.Content>
              <Tab.Pane eventKey="reports">
                <MessageReportList user={user} />
              </Tab.Pane>

              <Tab.Pane eventKey="moderation">
                <UserModerationPanel user={user} />
              </Tab.Pane>

              <Tab.Pane eventKey="announcements">
                <AnnouncementCreator user={user} />
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </Container>
  );
};

export default AdminPanel;
